import React, { useState } from "react";
import "./AdminPricing.css";
import { useDispatch } from "react-redux";
import { pricingUpdation } from "../../redux/AdminReducer";

const PricingAdminFields = () => {
  const dispatch = useDispatch();
  const [price, setPrice] = useState({
    distance: "",
    handLuggage: "",
    suitcase: "",
    backPack: "",
    perHour:"",
    ruckSack: "",
    snowboard: "",
    pairSkies: "",
    golfBag: "",
    bike: "",
    largBox: "",
    childItem: "",
    wheelchair: "",
    passenger:""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setPrice({
      ...price,
      [name]: value,
    });
  };

  console.log("price", price);

  const submitClicked = () => {
    let obj = [
      {
        value: price.distance,
        name: "distance",
      },
      {
        value: price.perHour,
        name: "perHour",
      },
      // {
      //   value: price.suitcase,
      //   name: "suitcase",
      // },

      // {
      //   value: price.backPack,
      //   name: "backPack",
      // },
      // {
      //   value: price.ruckSack,
      //   name: "ruckSack",
      // },
      // {
      //   value: price.snowboard,
      //   name: "snowboard",
      // },
      // {
      //   value: price.pairSkies,
      //   name: "pairSkies",
      // },
      // {
      //   value: price.golfBag,
      //   name: "golfBag",
      // },
      // {
      //   value: price.bike,
      //   name: "bike",
      // },
      // {
      //   value: price.largBox,
      //   name: "largBox",
      // },
      // {
      //   value: price.childItem,
      //   name: "childItem",
      // },

      // {
      //   value: price.wheelchair,
      //   name: "wheelchair",
      // },
      // {
      //   value: price.passenger,
      //   name: "passenger",
      // },
    ];

    dispatch(pricingUpdation(obj));
  };

  return (
    <>
      <div className="vehicleAdminMain">
        {/* <div className="topTextEditAdmVehic topTextEditAdmVehicPric">
          Enter the detail to calculate the price..
        </div> */}

        <div className="mainContainerFieldsPricing">
          <div className="topLabelInputPricing topLabelInputPricingRow">
            {/* <div className="topLabelInputPricing">
              <div className="lablePricingAdmin">Price Per Mile</div>

              <input
                placeholder="Enter Price Per Mile "
                className="inputFieldPricingAdm"
                onChange={handleChange}
                name="distance"
                type="number"
                value={price.distance}
              />
            </div> */}

            {/* <div className="topLabelInputPricing">
              <div className="lablePricingAdmin">Price Per Hour</div>

              <input
                placeholder="Enter Price Per Hour"
                className="inputFieldPricingAdm"
                onChange={handleChange}
                name="perHour"
                type="number"
                value={price.wheelchair}
              />
            </div> */}
            {/* <div className="topLabelInputPricing">
              <div className="lablePricingAdmin">Per Passenger</div>

              <input
                placeholder="Enter Single Pessenger Price"
                className="inputFieldPricingAdm"
                onChange={handleChange}
                name="passenger"
                type="number"
                value={price.passenger}
              />
            </div> */}
          </div>

          {/* <div className="topLuggageInputFields">
            <div className="lablePricingAdmin">Luggage Prices</div>
            <div className="top2RowsLuggPriAdm">
              <div className="firstRowLggPric">
                <input
                  placeholder="Enter Single Hand Luggage(56 x 37 x 25 cm) Price"
                  className="inputFieldPricingAdm"
                  onChange={handleChange}
                  type="number"
                  name="handLuggage"
                  value={price.handLuggage}
                />
              </div>
              <div className="firstRowLggPric">
                <input
                  placeholder="Enter Single  Suitcase(78 x 50 x 32 cm) Price"
                  className="inputFieldPricingAdm"
                  onChange={handleChange}
                  type="number"
                  name="suitcase"
                  value={price.suitcase}
                />
              </div>
            </div>
            <div className="top2RowsLuggPriAdm">
              <div className="firstRowLggPric">
                <input
                  placeholder="Enter Single Backpack Price"
                  className="inputFieldPricingAdm"
                  type="number"
                  onChange={handleChange}
                  name="backPack"
                  value={price.backPack}
                />
              </div>
              <div className="firstRowLggPric">
                <input
                  placeholder="Enter Single Rucksack Price"
                  className="inputFieldPricingAdm"
                  onChange={handleChange}
                  type="number"
                  name="ruckSack"
                  value={price.ruckSack}
                />
              </div>
            </div>
          </div>
          <div className="topLuggageInputFields">
            <div className="lablePricingAdmin">Outdoor items</div>
            <div className="top2RowsLuggPriAdm">
              <div className="firstRowLggPric">
                <input
                  placeholder="Enter Single Pair of skies Price"
                  className="inputFieldPricingAdm"
                  onChange={handleChange}
                  type="number"
                  name="pairSkies"
                  value={price.pairSkies}
                />
              </div>
              <div className="firstRowLggPric">
                <input
                  placeholder="Enter Single Snowboard Price"
                  className="inputFieldPricingAdm"
                  onChange={handleChange}
                  name="snowboard"
                  type="number"
                  value={price.snowboard}
                />
              </div>
            </div>
            <div className="top2RowsLuggPriAdm">
              <div className="firstRowLggPric">
                <input
                  placeholder="Enter Single Bike Price"
                  className="inputFieldPricingAdm"
                  onChange={handleChange}
                  name="bike"
                  type="number"
                  value={price.bike}
                />
              </div>
              <div className="firstRowLggPric">
                <input
                  placeholder="Enter Single Golf bag Price"
                  className="inputFieldPricingAdm"
                  onChange={handleChange}
                  name="golfBag"
                  type="number"
                  value={price.golfBag}
                />
              </div>
            </div>
            <div className="top2RowsLuggPriAdm">
              <div className="topLabelInputPricing">
                <div className="lablePricingAdmin">Boxes</div>

                <input
                  placeholder="Enter Single Large box (20 x 20 x 20 inches) Price"
                  className="inputFieldPricingAdm"
                  onChange={handleChange}
                  name="largBox"
                  value={price.largBox}
                  type="number"
                />
              </div>
              <div className="topLabelInputPricing">
                <div className="lablePricingAdmin">Child items</div>

                <input
                  placeholder="Enter Single Child item Price"
                  className="inputFieldPricingAdm"
                  onChange={handleChange}
                  name="childItem"
                  value={price.childItem}
                  type="number"
                />
              </div>
            </div>
          </div> */}
          {/* <div className="topLabelInputPricing">
            <div className="lablePricingAdmin">Folded wheelchiar</div>

            <input
              placeholder="Enter Single Folded wheelchiar Price"
              className="inputFieldPricingAdm"
              onChange={handleChange}
              name="wheelchair"
              type="number"
              value={price.wheelchair}
            />
          </div> */}
          {/* <div className="topLabelInputPricing">
            <button className="btnSubmitPricingAdm" onClick={submitClicked}>
              Submit
            </button>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default PricingAdminFields;
